import { createFileRoute } from '@tanstack/react-router'

import { Product } from '@/api/admin-products-types'
import { RouteModal } from '@/components/route-modal'
import { UnitOfMeasureForm } from '@/routes/_authenticated/_general/products/$productUuid/units/-form'

export const Route = createFileRoute('/_authenticated/_general/products/$productUuid/units/create')({
	component: CreateUnitOfMeasure
})

function CreateUnitOfMeasure() {
	const { productUuid } = Route.useParams()

	return (
		<RouteModal
			prev='..'
			asDrawer
			requiresData
			loader={async api => await api.getProduct({ path: { productUuid } })}
		>
			{(product: Product) => <UnitOfMeasureForm product={product} />}
		</RouteModal>
	)
}
